const SHIPPING_CARRIERS = {
  POSTNL: {
    id: 1,
    label: 'PostNL',
  },
  DHL: {
    id: 9,
    label: 'DHL',
  },
  DPD: {
    id: 4,
    label: 'DPD',
  },
  UPS: {
    id: 12,
    label: 'UPS',
  },
};

export const getFavoriteGenresOptions = () => [
  { key: 'rock', id: 'SignupForm.favoriteGenres.rock' },
  { key: 'pop', id: 'SignupForm.favoriteGenres.pop' },
  { key: 'elektronisch', id: 'SignupForm.favoriteGenres.electronic' },
  { key: 'hiphop', id: 'SignupForm.favoriteGenres.hiphop' },
  { key: 'soul_funk', id: 'SignupForm.favoriteGenres.soulFunk' },
  { key: 'Blues', id: 'SignupForm.favoriteGenres.blues' },
  { key: 'classical', id: 'SignupForm.favoriteGenres.classical' },
  { key: 'Reggae_Ska', id: 'SignupForm.favoriteGenres.Reggae_Ska' },
  { key: 'Folk_Country', id: 'SignupForm.favoriteGenres.Folk_Country' },
  { key: 'Metal', id: 'SignupForm.favoriteGenres.Metal' },
  { key: 'Soundtracks', id: 'SignupForm.favoriteGenres.Soundtracks' },
  { key: 'World', id: 'SignupForm.favoriteGenres.worldMusic' },
  { key: 'jazz', id: 'SignupForm.favoriteGenres.jazz' },
];



export default SHIPPING_CARRIERS;
